const data = [{
        "content": "针对5G及未来网络的移动自组网，采用机器学习或智能演化算法，对大规模感知物联网的自组织及数据传输进行建模与鲁棒性优化，为智慧城市的高鲁棒性物联网拓扑部署提供重要支撑。",
        "id": 1,
        "language": "汉语",
        "title": "智慧物联网"
    },
    {
        "content": "针对工业物联网结构与生产流程，研究时间敏感网络保证确定性传输，对工业协议进行智能解析，在边缘计算架构下卸载实时计算任务，设计基于数字孪生的生产环节优化方法，提升工业物联网的服务质量，使工业生产变得更加高效可靠。\n",
        "id": 2,
        "language": "汉语",
        "title": "工业物联网"
    },
    {
        "content": "针对非接触式体征健康监测，研究基于无线智能感知的定位技术与体征参数的无线感知，实现非接触式健康监测。使用无线智能感知技术进行非接触式体征健康监测，能够有效减少工作人员接触人员的风险，提高监测的效率。 ",
        "id": 3,
        "language": "汉语",
        "title": "智能无线感知"
    },
    {
        "content": "为应对智慧物联网中涌现的大量多模态数据，研究高效可信的模型协作方法，以提供可信赖的协作服务。同时构建多模态分析模型，增强数据分析能力，从而提升智慧物联网应用的服务质量。",
        "id": 4,
        "language": "汉语",
        "title": "可信大数据分析"
    },
    {
        "content": "For mobile self-organizing networks targeting 5G and future networks, utilizing machine learning or intelligent evolutionary algorithms to model and optimize the self-organization and data transmission of large-scale perception Internet of Things (IoT), providing crucial support for robust IoT topology deployment in smart cities.",
        "id": 5,
        "language": "英语",
        "title": "Smart Internet of Things"
    },
    {
        "content": "Focusing on the structure and production processes of the Industrial Internet of Things (IIoT), researching time-sensitive networking to ensure deterministic transmission, intelligently parsing industrial protocols, offloading real-time computing tasks under edge computing architecture, designing production process optimization methods based on digital twins, enhancing the service quality of IIoT, and making industrial production more efficient and reliable.",
        "id": 6,
        "language": "英语",
        "title": "Industrial Internet of Things:"
    },
    {
        "content": "For non-contact physiological health monitoring, research on wireless intelligent sensing-based localization technology and wireless sensing of physiological parameters to achieve non-contact health monitoring. Utilizing wireless intelligent sensing technology for non-contact physiological health monitoring can effectively reduce the risk of personnel contact and improve monitoring efficiency.",
        "id": 7,
        "language": "英语",
        "title": "Intelligent Wireless Sensing"
    },
    {
        "content": "To address the influx of large volumes of multimodal data emerging in the smart IoT domain, researching efficient and trustworthy model collaboration methods is essential to provide reliable collaborative services. Simultaneously, constructing multimodal analysis models enhances data analysis capabilities, thereby improving the service quality of smart IoT applications.",
        "id": 8,
        "language": "英语",
        "title": "Trusted Big Data Analysis"
    }
]

export default data;
